//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  Box,
  Divider,
  IconButton,
  TextField,
  Tooltip,
} from '@mui/material';
import { Add, Search, ContentCopy, ExpandMore, ExpandLess } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer } from 'components/Spacer';

// === UTILS ===

// === API ===

//#endregion

//-----------------------------------------------------------------
export function ControlBox(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const ref_add  = useRef     ();
  const theme    = useTheme   ();
  const navigate = useNavigate();

  const [ is_open_modal  , setIsOpenModal  ] = useState( false );
  const [ is_open_filter , setIsOpenFilter ] = useState( false );
  
  const [is_open_add, setIsOpenAdd] = useState(false);

  const expand_filter_icon = is_open_filter ? <ExpandLess /> : <ExpandMore />;

  const _tags = [
    { label: 'Is required document', group: 'Misc', filter: (rule) => rule.tags?.is_required_document },
  ];

  const search_value = localStorage.getItem( 'da-rule-list-search' );
  
  const is_light = theme.palette.mode === 'light';

  //#endregion

  //#region [STYLES]

  // === SX ===
  const _styles = {
    bar: {
      height       : 'max-content'   ,
      width        : '100%'   ,
      overflow     : 'hidden' ,
      borderRadius : '1rem'   ,
      overflow     : 'hidden' ,
      padding      : '1rem'   ,
    },
    container_main: {
      width   : '100%'   ,
      display : 'flex'   ,
      margin  : '0.5rem' ,
    },
    header_text: {
      fontSize: 'x-large',
      paddingLeft: '1rem',
      paddingTop: '0.8rem',
      color : theme.palette.primary.contrastColor,
    },
    search_text: {
      width: '100%',
      maxWidth: '50rem',
    },
    button_rule_add: {
      height: '3rem',
      margin: '0 0.5rem',
      whiteSpace: 'nowrap',
    },
    dropdown_add: {
      display : is_open_add ? '' : 'none',
      width   : '7rem',
      top     : '10.5rem',
      right   : '6rem',
      position: 'absolute',
      zIndex  : 50,
      // padding:'0.5rem',
    },
    container_filter: {
      display: is_open_filter ? 'flex' : 'none',
      width: '100%',
      justifyContent: 'center',
    },
    filter_tags: {
      minWidth: '40rem',
    },
    header: {
      display: 'flex',
      fontSize: '2rem',
    },
  };

  // === ATTRIBUTES ===

  const HEADER = {
    style: _styles.header,
  };

  const
    CONTAINER = {
      style: _styles.bar,
    },
    CONTAINER_FILTER = {
      style: _styles.container_filter,
    },
    TEXT_SEARCH = {
      sx: _styles.search_text,
      label: 'Search...',
      value: search_value,
      value: search_value,
      size : 'small', 
      onChange : onChangeSearch,
      name : 'da_rule_list_search_input',
    },
    BUTTON_ADD = {
      sx: _styles.button_add,
      ref: ref_add,
      children: <Add />,
      onClick: onClick_Add,
      name    : 'da_add_rule_btn',
    },
    BUTTON_DUPLICATE = {
      sx: _styles.button_duplicate,
      children: <ContentCopy />,
      disabled: true,
      onClick: onClick_Duplicate,
      name    : 'da_duplicate_rule_btn',
    },
    BUTTON_EXPAND = {
      children: [expand_filter_icon],
      onClick: () => { setIsOpenFilter(!is_open_filter) },
      name    : 'da_expand_rule_list_btn',
    },
    FILTER_TAGS = {
      id          : 'filter-tags',
      sx          : _styles.filter_tags,
      multiple    : true,
      options     : _tags,
      groupBy     : (option) => option.group,
      renderInput : (params) => { return <TextField {...params} variant='standard' label="Filter Tags" /> },
      onChange    : (event, value) => { props.onFilter( value.map( x => x.filter ) ) },
    };

  //#endregion

  //#region [PROCES]
  
  props.onSearch( search_value?.toUpperCase() )

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if(is_open_add) document.addEventListener   ( 'click', handleClickOutside, true );
    else        document.removeEventListener( 'click', handleClickOutside, true );

    return () => {
      if(is_open_add) document.removeEventListener('click', handleClickOutside, true);
    };
  }, [is_open_add]);

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Add(event) {
    //-----------------------------------------------------------------
    try {
      setIsOpenAdd(!is_open_add);
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref_add.current && !ref_add.current.contains(event.target)) {
      setIsOpenAdd(false);
    }
  }

  //-----------------------------------------------------------------
  function onClick_Duplicate(event) {
    //-----------------------------------------------------------------
    try {

    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onChangeSearch(event) {
    //-----------------------------------------------------------------
    try {
      const search = event.target.value;
      localStorage.setItem( 'da-rule-list-search', search );
      props.onSearch( search?.toUpperCase() )
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER }>
        <div { ...HEADER }>
          <div>Rules:</div>
          <Spacer width='6rem' />
          <div>{props.count}</div>
          <Spacer fill />
          <IconButton> <Search /> </IconButton>
          <TextField { ...TEXT_SEARCH }/>
          <Spacer />
          <IconButton { ...BUTTON_EXPAND } />
          <Spacer fill />
          <Spacer width='6rem' />
          <Tooltip title='Add rule' placement='top'>
            <IconButton { ...BUTTON_ADD  } />
          </Tooltip>
          <div style={_styles.dropdown_add}>
            <div style={{
              backgroundColor: theme.palette.background.paper,
              boxShadow: '-0.5px 1px 3px ' + (is_light ? 'black' : 'white'),
              width: '100%',
              padding:'0.5rem',
              borderRadius: '0rem 0.5rem 0.5rem 0.5rem',
              
              "&:last-child": {
                paddingBottom: 0.5,
              }
            }}>
              <Box sx={{
                display    : 'flex'  ,
                marginLeft : 'auto'  ,
                alignItems : 'center',
                padding    : '0.5rem' ,
                cursor     : 'pointer',
                fontSize   : '1.2rem',
                zIndex     : '50',
                '&:hover': {
                  background: theme.palette.background.secondary[theme.palette.mode],
                },
              }} onClick={()=>navigate( 'new' )}>Rule</Box>
              <Divider />
              <Box sx={{
                display    : 'flex'  ,
                marginLeft : 'auto'  ,
                alignItems : 'center',
                padding    : '0.5rem' ,
                cursor     : 'pointer',
                fontSize   : '1.2rem',
                zIndex     : '50',
                '&:hover': {
                  background: theme.palette.background.secondary[theme.palette.mode],
                },
              }} onClick={()=>{navigate( 'new', { state: { type: 'template' } } )}}
              >Template</Box>
            </div>
          </div>
          <Tooltip title='Duplicate rule' placement='top'>
            <IconButton { ...BUTTON_DUPLICATE } />
          </Tooltip>
          <IconButton { ...BUTTON_EXPAND } />
        </div>
        <div { ...CONTAINER_FILTER }>
          <Spacer fill />
          <Autocomplete { ...FILTER_TAGS }/>
          <Spacer fill />
        </div>
      </div>
    );
  }

  //#endregion

  return display();
}